export default {
    API_SERVER: process.env.VUE_APP_API_SERVER || window.env.VUE_APP_API_SERVER,
    APP_SERVER: process.env.VUE_APP_SERVER || window.env.VUE_APP_SERVER
};
